/* eslint-disable prettier/prettier */
/* prettier-ignore-file */
/* eslint-disable */
import { FunctionComponent } from 'react';
import styles from '../../styles/components/controlVariations/Cta2.module.css';

interface CTA2Props {
	leftIcon?: string;
	title: string;
	rightIcon?: string;
	onClick?: () => void;
	type?: 'button' | 'submit';
}

const CTA2: FunctionComponent<CTA2Props> = ({
	leftIcon,
	title,
	rightIcon,
	onClick,
	type = 'button',
}) => {
	return (
		<button
			type={type}
			className={styles.property1default}
			onClick={onClick}
		>
			{leftIcon && (
				<img
					className={styles.vectorIcon}
					src={leftIcon}
					alt=""
					aria-hidden="true"
				/>
			)}

			<span className={styles.loginWithGoogle}>{title}</span>

			{rightIcon && (
				<img
					className={styles.iconplus}
					src={rightIcon}
					alt=""
					aria-hidden="true"
				/>
			)}
		</button>
	);
};

export default CTA2;
